module.exports = __webpack_public_path__ + "img/business_1_2.59f97291.png";